import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { NameType } from '../../shared/models/models';
import { Ignorering } from '../models/ignore';

@Injectable({
  providedIn: 'root',
})

export class IgnoreradeService {
  urls = {
    SMITTAMNE: 'namelists/ignorelists/SMITTAMNE',
    ANTIBIOTIKUM: 'namelists/ignorelists/ANTIBIOTIKUM',
    ANALYS: 'namelists/ignorelists/ANALYS',
    PROVMATERIAL: 'namelists/ignorelists/PROVMATERIAL',
    NEGATIVT: '',
    BESKRIVANDE: '',
  };

  constructor(private apiService: ApiService) {}

  getIgnoreList(type: NameType) {
    const url = this.urls[type];
    return this.apiService.get<Ignorering[]>(url).catch((error) => []);
  }

  putIgnorering(nameType: NameType, ignorering: Ignorering): Promise<Ignorering> {
    const url = `${this.urls[nameType]}/${ignorering.id}`;
    return this.apiService.put<Ignorering>(url, ignorering);
  }
}
